import { render, staticRenderFns } from "./table-cell-active.vue?vue&type=template&id=0a0b3ff1&"
import script from "./table-cell-active.vue?vue&type=script&lang=js&"
export * from "./table-cell-active.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports